import { CheckCircle, Clock, XCircle, MinusCircle } from "lucide-react";

const CATEGORY_COLORS = {
  Climate: "#10B981", Housing: "#3B82F6", Economy: "#F59E0B", Indigenous: "#DC2626",
  Disability: "#8B5CF6", Environment: "#059669", Integrity: "#6366F1", Defence: "#1E40AF",
  Education: "#0EA5E9", "Social Policy": "#EC4899", "Gambling Reform": "#D97706",
  "Foreign Policy": "#64748B", Energy: "#EF4444", Immigration: "#7C3AED",
  Agriculture: "#065F46", "Digital Safety": "#0891B2", "Human Rights": "#BE185D",
  default: "#6B7280",
};

const STATUS_CFG = {
  delivered:   { label: "Delivered",   color: "#10B981", Icon: CheckCircle },
  in_progress: { label: "In Progress", color: "#3B82F6", Icon: Clock },
  broken:      { label: "Broken",      color: "#EF4444", Icon: XCircle },
  not_started: { label: "Not Started", color: "#6B7280", Icon: MinusCircle },
};

export function CampaignPromisesSection({ promises, isDark, surface, text, textSec }) {
  if (!promises || promises.length === 0) return null;

  const delivered = promises.filter((p) => p.status === "delivered").length;
  const pct = Math.round((delivered / promises.length) * 100);

  return (
    <section data-testid="promises-section">
      <h2 className="text-xl font-black mb-4 pb-2 border-b-2 border-black flex items-center justify-between" style={{ color: text, fontFamily: "Outfit, sans-serif" }}>
        <span>
          Campaign Promises
          <span className="text-sm font-bold ml-2" style={{ color: textSec }}>({promises.length} tracked)</span>
        </span>
        <span className="text-sm font-black px-2.5 py-1 border-2 border-black" style={{ backgroundColor: "#10B981", color: "#fff" }}>
          {pct}% delivered
        </span>
      </h2>
      <div className="space-y-3">
        {promises.map((promise) => {
          const cfg = STATUS_CFG[promise.status] || STATUS_CFG.not_started;
          const StatusIcon = cfg.Icon;
          const cardBg = promise.status === "delivered"
            ? (isDark ? "#052E16" : "#F0FDF4")
            : promise.status === "broken"
            ? (isDark ? "#1F0A0A" : "#FEF2F2")
            : promise.status === "in_progress"
            ? (isDark ? "#0A1628" : "#EFF6FF")
            : (isDark ? "#111827" : "#F9FAFB");
          return (
            <div key={promise.id} className="border-2 border-black p-4" style={{ backgroundColor: cardBg, boxShadow: "2px 2px 0 #000" }} data-testid={`promise-${promise.id}`}>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 flex items-center gap-1 px-2 py-0.5 border-2 border-black text-xs font-black text-white" style={{ backgroundColor: cfg.color }}>
                  <StatusIcon className="w-3 h-3" />
                  {cfg.label}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-black text-sm mb-1" style={{ color: text }}>{promise.promise}</p>
                  <p className="text-xs leading-relaxed mb-1.5" style={{ color: textSec }}>{promise.evidence}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-xs px-1.5 py-0.5 border" style={{ color: CATEGORY_COLORS[promise.category] || "#6B7280", borderColor: CATEGORY_COLORS[promise.category] || "#6B7280" }}>
                      {promise.category}
                    </span>
                    <span className="text-xs" style={{ color: textSec }}>{promise.source}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
